<template>
  <div class="app-circle">
    <AppIcon shape="ai-agent" color="primary" />
  </div>
</template>

<style scoped lang="scss">
.app-circle {
  @apply tw-rounded-full tw-h-[34px] tw-min-w-[34px] tw-flex tw-items-center tw-justify-center tw-bg-blue-50;
}
</style>
